import { BRAND_BLUE, BRAND_BLUE_DARK, BRAND_BLUE_DARK_RGB, BRAND_BLUE_RGB, BRAND_INK, CANVAS_BG } from './tl-brand-tokens.js';
/** Re-tint the palette's "blue" family to the brand blue. */
function brandBluePalette(colors, dark) {
    const blue = colors.blue;
    if (typeof blue !== 'object' || blue === null)
        return colors;
    const solid = dark ? BRAND_BLUE_DARK : BRAND_BLUE;
    return {
        ...colors,
        blue: {
            ...blue,
            solid,
            fill: solid,
            linedFill: dark ? blue.linedFill : '#5a82f7',
            frameHeadingStroke: dark ? blue.frameHeadingStroke : '#6f8ff5',
            frameHeadingFill: dark ? blue.frameHeadingFill : '#f7f9ff',
            frameStroke: dark ? blue.frameStroke : '#6f8ff5',
            frameFill: dark ? blue.frameFill : '#f7f9ff',
            noteFill: dark ? blue.noteFill : '#91a9ff',
            semi: dark ? blue.semi : '#e3e9fd',
            pattern: dark ? blue.pattern : '#5a82f7',
        },
    };
}
/** Re-tint the special (string) theme colors: selection, marquee, ink, surface. */
function brandSpecials(colors, dark) {
    const lightOnly = dark
        ? {}
        : { text: BRAND_INK, background: CANVAS_BG, negativeSpace: CANVAS_BG };
    return {
        ...colors,
        ...lightOnly,
        selectionStroke: dark ? BRAND_BLUE_DARK : BRAND_BLUE,
        selectionFill: `rgba(${dark ? BRAND_BLUE_DARK_RGB : BRAND_BLUE_RGB}, ${dark ? '0.22' : '0.15'})`,
        brushFill: dark ? 'rgba(148, 163, 184, 0.12)' : 'rgba(100, 116, 139, 0.1)',
        brushStroke: dark ? 'rgba(148, 163, 184, 0.3)' : 'rgba(100, 116, 139, 0.28)',
    };
}
/** Apply the brand theme patch to a freshly mounted tldraw editor. */
export function applyBrandTheme(editor) {
    const base = editor.getTheme('default');
    if (base === undefined)
        return;
    editor.updateTheme({
        ...base,
        colors: {
            light: brandBluePalette(brandSpecials(base.colors.light, false), false),
            dark: brandBluePalette(brandSpecials(base.colors.dark, true), true),
        },
    });
}
//# sourceMappingURL=tl-brand-theme.js.map